import { render, staticRenderFns } from "./team.vue?vue&type=template&id=f954b4c0"
import script from "./team.ts?vue&type=script&lang=js&external"
export * from "./team.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports